module.exports = __webpack_public_path__ + "files/8a0cfaa7540378dc2bc6e883120d10f5.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lato-bolditalic-webfont.woff2
// module id = 836
// module chunks = 60